export default "__VITE_ASSET__765617f1__"